function lookupAnswer(questions, answers, questionReference) {
    let question = (questions || []).find(q => q.id === questionReference || q.key == questionReference);
    if (question && question.id) {
        let answer = (answers || []).find(a => question && a.questionId === question.id);
        return answer;
    }
    return undefined;
}
function lookupSelectedKeys(questions, answers, questionReference) {
    let question = (questions || []).find(q => q.id === questionReference || q.key == questionReference);
    if (question && question.id) {
        let answer = (answers || []).find(a => question && a.questionId === question.id);
        if (answer) {
            return (answer.selections || []).map(s => {
                let selectedPrompt = (question.prompts || []).find(p => p.id === s);
                if (selectedPrompt) {
                    return selectedPrompt.key;
                }
                else {
                    return null;
                }
            });
        }
        return [];
    }
    return [];
}
export class NoOpRuleEvaluator {
    evaluate(_questions, _answers) {
        return true;
    }
    get asJson() {
        return {};
    }
    dependsOnKey(_) {
        return false;
    }
}
class BinaryValueRuleEvaluator {
    constructor(questionId) {
        this.questionId = questionId;
    }
    evaluate(questions, answers) {
        let answer = lookupAnswer(questions, answers, this.questionId);
        if (answer) {
            return !!answer.booleanAnswer;
        }
        return false;
    }
    get asJson() {
        return {
            operator: "binaryvalue",
            question: this.questionId,
        };
    }
    dependsOnKey(key) {
        return key === this.questionId;
    }
}
class NaryValueRuleEvaluator {
    constructor(questionId, targetValue) {
        this.questionId = questionId;
        this.targetValue = targetValue;
    }
    evaluate(questions, answers) {
        const selectedKeys = lookupSelectedKeys(questions, answers, this.questionId);
        return selectedKeys.indexOf(this.targetValue) >= 0;
    }
    get asJson() {
        return {
            operator: "naryvalue",
            question: this.questionId,
            contains: this.targetValue,
        };
    }
    dependsOnKey(key) {
        return key === this.questionId;
    }
}
class NaryAnyRuleEvaluator {
    constructor(questionId) {
        this.questionId = questionId;
    }
    evaluate(questions, answers) {
        const selectedKeys = lookupSelectedKeys(questions, answers, this.questionId);
        return selectedKeys.length > 0;
    }
    get asJson() {
        return {
            operator: "naryany",
            question: this.questionId,
        };
    }
    dependsOnKey(key) {
        return key === this.questionId;
    }
}
class AndRuleEvaluator {
    constructor(operand0, operand1) {
        this.operand0 = operand0;
        this.operand1 = operand1;
    }
    evaluate(questions, answers) {
        if (this.operand0.evaluate(questions, answers)) {
            return this.operand1.evaluate(questions, answers);
        }
        return false;
    }
    get asJson() {
        return {
            operator: "and",
            operand0: this.operand0.asJson,
            operand1: this.operand1.asJson,
        };
    }
    dependsOnKey(key) {
        return this.operand0.dependsOnKey(key) || this.operand1.dependsOnKey(key);
    }
}
class OrRuleEvaluator {
    constructor(operand0, operand1) {
        this.operand0 = operand0;
        this.operand1 = operand1;
    }
    evaluate(questions, answers) {
        if (this.operand0.evaluate(questions, answers)) {
            return true;
        }
        return this.operand1.evaluate(questions, answers);
    }
    get asJson() {
        return {
            operator: "or",
            operand0: this.operand0.asJson,
            operand1: this.operand1.asJson,
        };
    }
    dependsOnKey(key) {
        return this.operand0.dependsOnKey(key) || this.operand1.dependsOnKey(key);
    }
}
export class RuleParser {
    static parse(rules) {
        if (!rules) {
            return null;
        }
        switch (rules["operator"]) {
            case "binaryvalue":
                return new BinaryValueRuleEvaluator(rules["question"]);
            case "naryvalue":
                return new NaryValueRuleEvaluator(rules["question"], rules["contains"]);
            case "naryany":
                return new NaryAnyRuleEvaluator(rules["question"]);
            case "and":
                return new AndRuleEvaluator(RuleParser.parse(rules["operand0"]), // TODO fix ! assertion
                RuleParser.parse(rules["operand1"]));
            case "or":
                return new OrRuleEvaluator(RuleParser.parse(rules["operand0"]), // TODO fix ! assertion
                RuleParser.parse(rules["operand1"]));
        }
        console.error("Rules", rules);
        throw new Error(`Unknown type ${rules["operator"]}.`);
    }
}
//# sourceMappingURL=rule.js.map